import StatusBadge from "./StatusBadge";

function Bracket({
  rounds = [],
  canManage = false,
  onStartRound,
  onCloseRound,
  onResolveMatch,
  onOpenMatch,
  emptyTitle = "No bracket generated yet",
  emptyNote = "Register teams, assign seeds if needed, then generate the bracket.",
}) {
  if (!rounds.length) {
    return (
      <div className="matchEmptyState">
        <strong>{emptyTitle}</strong>
        <span>{emptyNote}</span>
      </div>
    );
  }

  return (
    <div className="appBracketGrid">
      {rounds.map((round) => (
        <div key={`app-round-${round.id}`} className="appBracketRound">
          <div className="appBracketRoundHeader">
            <div>
              <strong>{round.round_name}</strong>
              <span>{humanizeStatus(round.status)}</span>
            </div>
            {canManage ? (
              <div className="appBracketRoundActions">
                {round.status === "upcoming" && (
                  <button
                    className="secondaryButton inlineActionButton"
                    type="button"
                    onClick={() => onStartRound?.(round)}
                  >
                    Start Round
                  </button>
                )}
                {round.status === "active" && (
                  <button
                    className="secondaryButton inlineActionButton"
                    type="button"
                    onClick={() => onCloseRound?.(round)}
                  >
                    Close Round
                  </button>
                )}
              </div>
            ) : null}
          </div>

          <div className="appBracketMatchList">
            {(round.matches || []).map((match) => (
              <div key={`app-match-${match.id}`} className={`appBracketMatch is-${String(match.status || "scheduled").replace(/_/g, "-")}`}>
                <button
                  type="button"
                  className="appBracketMatchBody"
                  onClick={() => onOpenMatch?.(match)}
                >
                  <div className="appBracketMatchTop">
                    <span className="appBracketSlot">Match {match.bracket_position || match.id}</span>
                    <StatusBadge status={match.status} />
                  </div>

                  <div className="appBracketTeams">
                    <div className={`appBracketTeam ${match.winner_team_id === match.team_a_id ? "isWinner" : ""}`}>
                      <strong>{match.team_a_name || "TBD"}</strong>
                      <span>{Number(match.team_a_score || 0)}</span>
                    </div>
                    <div className={`appBracketTeam ${match.winner_team_id === match.team_b_id ? "isWinner" : ""}`}>
                      <strong>{match.team_b_name || "TBD"}</strong>
                      <span>{Number(match.team_b_score || 0)}</span>
                    </div>
                  </div>

                  <p className="appBracketMeta">
                    {match.platform === "mixed" ? "Mixed boards" : `${match.platform} boards`} | {match.time_control || "clock pending"} | {match.board_count || 0} boards
                  </p>
                </button>

                {canManage && !match.winner_team_id && match.team_a_id && match.team_b_id ? (
                  <div className="appBracketResolve">
                    <button
                      className="secondaryButton inlineActionButton"
                      type="button"
                      onClick={() => onResolveMatch?.(match, match.team_a_id)}
                    >
                      Advance {match.team_a_name}
                    </button>
                    <button
                      className="secondaryButton inlineActionButton"
                      type="button"
                      onClick={() => onResolveMatch?.(match, match.team_b_id)}
                    >
                      Advance {match.team_b_name}
                    </button>
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function humanizeStatus(status) {
  return String(status || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export default Bracket;
